$(document).ready(function(){
  setFrequencyDropDown()
  setDiscounts()
  let stored_frequency = sessionStorage.getItem('frequency_selected')
  if(stored_frequency!=null){
    $('#frequencySelected').val(stored_frequency)
    if (stored_frequency == 0){
        $('#frequencyMessage').text('Subscribe and save 5%').addClass('text-danger').removeClass('text-success')
    }
    if (stored_frequency > 0){
        $('#frequencyMessage').text("You're saving 5% by subscribing").addClass('text-success').removeClass('text-danger')
    }
  }else{
    let first_load = sessionStorage.getItem('first_load')
    sessionStorage.setItem('frequency_selected', 1)
    $('#frequencySelected').val(1)
    if (first_load != false){
      updateFrequency(false)
    }
  }
  let stored_delivery_date = sessionStorage.getItem('delivery_date_selected')
  if (stored_delivery_date != null){
    $('#delivery_date').val(stored_delivery_date)
    $('#checkout_btn').removeClass('disabled')
  }
});


function validate_checkout(){
  if ($("input[class='pickadate']").length > 0){
    let date_picked = $("input[class='pickadate']")[0].value
    console.log('date_picked', date_picked)
    invalid_date = new Date(date_picked) == 'Invalid Date'
    if (invalid_date === true){
      $('#checkout_warning_text').fadeToggle(500).delay(2000).fadeToggle()
      return false
    }else{
    }
    window.location.href="/checkout";
  }else{
    window.location.href="/checkout";
  }
}

function check_basket_health(){
    let existing =  JSON.parse(sessionStorage.getItem('basket_history'))
    console.log((existing.length))
    let time_now = Date.now()
    $(existing.reverse()).each(function(index, value) {
      let basket_time = value.time
      let basket_age = time_now-basket_time
      let number_items = value['data']['items'].length
      if (number_items > 0 && basket_age < max_rebuild_age){
        console.log('use this', value)
        rebuild_basket(value)
        location.reload();
      }
    });
}

function setDiscounts(){
  jQuery.ajax({
  type: 'GET',
  url: '/cart.js',
  dataType: 'json',
  success: function(data, status) {
    let cart_items = data['items']
    let cart_total = 0
    $.each(cart_items, function(cart_item_index, cart_item){
      let variant_id = cart_item['id']
      let quantity = $('#cart_item_'+variant_id).val()
      let selling_plan_allocation = cart_item['selling_plan_allocation']
      let active_price
      if (selling_plan_allocation != undefined){
        let compare_at_price = (selling_plan_allocation['compare_at_price']/100).toLocaleString("en-US", {style:"currency", currency:"GBP"});
        let per_delivery_price = (selling_plan_allocation['per_delivery_price']/100).toLocaleString("en-US", {style:"currency", currency:"GBP"});
        console.log(compare_at_price, per_delivery_price, cart_item)
        active_price = selling_plan_allocation['per_delivery_price']/100
        let new_text = `<strike class="text-danger">${compare_at_price}</strike> ${per_delivery_price}`
        $(`#final_price_${variant_id}`).html(new_text).addClass('text-success')
      }else{
        active_price = $('#final_price_'+variant_id).text().replace('£','').trim()
      }
        console.log('active_price',active_price)

      $('#item_final_price_'+variant_id).text(((active_price * quantity)).toLocaleString("en-US", {style:"currency", currency:"GBP"}))
      let line_item_price = active_price * quantity
      if (!isNaN(line_item_price)){
        cart_total = cart_total+(line_item_price)
      }
    })
    $('#your_first_payment_amount').text((cart_total).toLocaleString("en-US", {style:"currency", currency:"GBP"}))

  }
});

}

function updatePage(){
  $('#your_first_payment_amount').text('new amount')
}

function setQuantity(variant_id, current_q, adjustment){
  var current_q = $('#cart_item_'+variant_id).val()
  let new_q = (current_q*1) + adjustment
  let exisiting_date = $("input.pickadate:text")[0].value
  if (new_q == 0){
    $('#basket_row_'+variant_id).remove()
  }
  let data = { "quantity": new_q, "id": variant_id }
  jQuery.ajax({
    type: 'POST',
    url: '/cart/change.js',
    data: data,
    dataType: 'json',
    success: function() {
      $('#cart_item_'+variant_id).val($('#cart_item_'+variant_id).val()*1 + (adjustment*1))
      setDiscounts()
      $("input.pickadate:text")[0].value = exisiting_date
        console.log(exisiting_date)
    }
  });
}

function setDeliveryDate(){
  let delivery_date = $('#delivery_date').val()
  sessionStorage.setItem('delivery_date_selected',delivery_date)
  let data = {
  attributes: {
    'Delivery': delivery_date
    }
  }
  jQuery.ajax({
    type: 'POST',
    url: '/cart/update.js',
    data: data,
    dataType: 'json',
    success: function() {
      $('#checkout_btn').removeClass('disabled')
      $('#checkout_warning_text').addClass('d-none')
    }
  });
}

function setItemFrequency(data) {
  jQuery.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: {"items":data},
    dataType: 'json',
    success: function() {
      let first_load = sessionStorage.setItem('first_load', false)
      console.log('success')
      // window.location.href = '/cart';
    }
  });
}

function justOnce(variant_id){
  console.log('make this just once', variant_id)
  let exisitng_just_once_items = JSON.parse(sessionStorage.getItem('justOnce'))
  console.log(exisitng_just_once_items)
  if (exisitng_just_once_items === null){
    console.log('nothing set in justOnce')
    sessionStorage.setItem('justOnce', JSON.stringify([variant_id*1]))
  }else{
    exisitng_just_once_items.push(variant_id*1)
    sessionStorage.setItem('justOnce', JSON.stringify(exisitng_just_once_items))
  }
  updateFrequency(true)
}

function clearCart(){
  jQuery.ajax({
    type: 'POST',
    url: '/cart/clear.js',
    data: '',
    dataType: 'json',
    success: function() {
      console.log('clear success')
    }
  });
}

function setFrequencyDropDown() {
  jQuery.ajax({
    type: 'GET',
    url: '/cart.js',
    dataType: 'json',
    success: function(data, status) {
      let items = data['items']
      let frequency_selected_value = 0
      $.each(items, function(item_index, item_value){
        let selling_plan_allocation = item_value['selling_plan_allocation']
        let selling_plan_name
        if (selling_plan_allocation != undefined){
          console.log('selling_plan_allocation',selling_plan_allocation, 'not equal to undefined')
          selling_plan_name = selling_plan_allocation['selling_plan']['name']
          frequency_selected_value = selling_plan_name.match(/\d+/)[0]
        }

      })
      $('#frequencySelected').val(frequency_selected_value)
      sessionStorage.setItem('frequency_selected', frequency_selected_value)
    }
  });
}

function make_entire_basket_one_off(){
  sessionStorage.setItem('justOnce', JSON.stringify([]))
  sessionStorage.setItem('frequency_selected', '0')
  let recharge_data = JSON.parse($('#recharge_json').text())
  let items = recharge_data['items']
  let updated_items = []
  $.each(items, function(item_index, item_value){
    let variant_id = item_value['variant_id']
    let key = item_value['key']

    let quantity = $( `input.js-qty__num.js-qty-input[data-id='${key}']` ).val();

    console.log('Setting for variant_id',variant_id)
    updated_items.push({
      "id": variant_id,
      "quantity": quantity
    })
  })
  setItemFrequency(updated_items)
  // jQuery.ajax({
  //   type: 'POST',
  //   url: '/cart/clear.js',
  //   data: '',
  //   dataType: 'json',
  //   success: function() {
  //     $.each(items, function(item_index, item_value){
  //       let variant_id = item_value['variant_id']
  //       let quantity = $(`#cart_item_${variant_id}`).val()
  //       console.log('Setting for variant_id',variant_id)
  //       updated_items.push({
  //         "id": variant_id,
  //         "quantity": quantity
  //       })
  //     })
  //     setItemFrequency(updated_items)
  //     $('#your_first_payment').text('Total to pay')
  //   }
  // })
}


function updateFrequency(make_just_once){
  if (make_just_once !== true){
    sessionStorage.setItem('justOnce', JSON.stringify([]))
    var just_once_items = []
  }else{
    var just_once_items = JSON.parse(sessionStorage.getItem('justOnce'))
    if (just_once_items === null){
      just_once_items = []
    }
  }
  let frequency_selected = $('#frequencySelected').val()*1
  if (frequency_selected === 0){
    console.log('make_entire_basket_one_off')
    make_entire_basket_one_off()
    return false
  }
  sessionStorage.setItem('frequency_selected',frequency_selected)
  let recharge_data = JSON.parse($('#recharge_json').text())
  let items = recharge_data['items']
  jQuery.ajax({
    type: 'POST',
    url: '/cart/clear.js',
    data: '',
    dataType: 'json',
    success: function() {
      var updated_items = []
      $.each(items, function(item_index, item_value){
        let selling_plans = item_value['recharge_data']['selling_plans']
        let variant_id = item_value['variant_id']
        console.log('Setting for variant_id',variant_id)
        let quantity = $(`#cart_item_${variant_id}`).val()
        if (just_once_items.includes(variant_id*1) && make_just_once == true){
          updated_items.push({
            "id": variant_id,
            "quantity": quantity
          })
        }else{
          $.each(selling_plans, function(selling_plan_index, selling_plan_data){
            let selling_plan_id = selling_plan_data['selling_plan_id']
            let order_frequency = selling_plan_data['order_interval_frequency']*1
            let quantity = $(`#cart_item_${variant_id}`).val()
            if (frequency_selected===order_frequency){
              updated_items.push({
                "id": variant_id,
                "quantity": quantity,
                "selling_plan": selling_plan_id
              })
            }
          })
      }
      })
      setItemFrequency(updated_items)
    }
  })
}
